import Component from 'components/pages/Blog/BlogPosts.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export default buildPage(Component, {
  requiresAuthentication: false,
  skipSSR: true,
  metaData: {
    title: 'Blog',
    description: 'Come and check out the Qmee blog and find out more about us.',
  },
});

export const getStaticProps = buildStaticProps('blog', {
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
